import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { HttpClient } from '@angular/common/http';
// import * as qz from 'qz-tray';
declare var qz: any;
declare var RSAKey: any;
declare var stob64: any;
declare var hextorstr: any;
declare var strip: any;
declare var KEYUTIL: any;
declare var KJUR: any;


@Injectable({
  providedIn: 'root'
})
export class QzTrayService {


  isHexa: Boolean = false;
  constructor(protected http: HttpClient) {
  }

  setSignature(certificat, privateKey) {
    console.log(certificat, privateKey);
    qz.security.setCertificatePromise(function (resolve, reject) {
      resolve(certificat);
    });
    qz.security.setSignaturePromise(function (toSign) {
      return function (resolve, reject) {
        try {
          const pk = KEYUTIL.getKey(privateKey);
          const sig = new KJUR.crypto.Signature({ 'alg': 'SHA1withRSA' });
          sig.init(pk);
          sig.updateString(toSign);
          const hex = sig.sign();
          console.log('DEBUG: \n\n' + stob64(hextorstr(hex)));
          resolve(stob64(hextorstr(hex)));
        } catch (err) {
          console.log('erreur signature');
          console.error(err);
          reject(err);
        }
      };
    });
  }


  impression(nomImp, contenu?, isHexa?) {
    this.isHexa = isHexa || false;
    return this.connect(nomImp, contenu).then(() => {
      console.log('connect success', nomImp, contenu)
      return this.findPrinter(nomImp, contenu);
    }).catch(err => {
      console.log('connect fail', err)
    });
  }

  closeImprimante() {
    return qz.websocket.disconnect();
  }

  findPrinter(nomImp, contenu) {
    // find printer on PC with "PC43" in the name
    console.log(nomImp)
    console.log('findPrinter', nomImp, contenu)
    return qz.printers.find(nomImp || 'PC43').then((found) => {
      console.log('Printer: ' + found);
      if (!this.isHexa) {
        contenu = contenu.replace('"', '').split('\',\'');
        console.log('Contenu impression : ', contenu);
        return this.print(found, contenu);
      } else {
        const objetToPrint = [
          {
            flavor: 'hex',
            data: contenu,
            options: {
              language: 'TEC'
            }
          }
        ]
        console.log('Contenu impression hexa : ', objetToPrint);
        return this.print(found, objetToPrint);
      }
    }).catch(err => {
      console.log('findPrinter fail', err);
    });
  }

  success() {
    console.log('Print OK');
  }

  // exception catch-all
  fail(e) {
    console.log('Error: ' + e);
  }

  connect(nomImp, contenu) {
    const ctrl = this;

    return new Promise((resolve, reject) => {
      if (qz.websocket.isActive()) {	// if already active, resolve immediately
        console.log('if already active, resolve immediately')
        return this.findPrinter(nomImp, contenu);
      } else {
        // try to connect once before firing the mimetype launcher
        qz.websocket.connect().then(resolve, function retry() {
          // if a connect was not successful, launch the mimetime, try 3 more times
          window.location.assign('qz:launch');
          qz.websocket.connect({ retries: 2, delay: 1 }).then(resolve, () => {
            ctrl.fail('Unable to connect to qz-tray');
          });
        });
      }
    });
  }



  // print logic
  print(printer, elementToPrint?) {
    const config = qz.configs.create(printer);

    // TODO recuperer la trame d'imporession ZPL
    const data = ['^XA',
      '^FO60,50^AUN,18,10^FB600,1,0,C,0^FD@Societe^FS',
      '^FO60,150^ARN,18,10^FB600,1,0,C,0^FD@Ville^FS',
      '^FO60,200^ARN,18,10^FB600,1,0,C,0^FD@NumRue^FS',
      '^FO60,250^ARN,18,10^FB600,1,0,C,0^FD@TypeVoie^FS',
      '^FO60,300^ARN,18,10^FB600,1,0,C,0^FD@NomVoie^FS',
      '^FO200,350^B3N,N,100,N,N^FD29005885^FS',
      '^FO60,500^ARN,18,10^FDType de bac : @TypeContenant^FS',
      '^FO60,550^ARN,18,10^FDNumero de bac : @NumBac^FS',
      '^FO60,650^ARN,18,10^FD.^FS',
      '^XZ'];

      console.log('fonction print', printer, elementToPrint)

    // return the promise so we can chain more .then().then().catch(), etc.
    return qz.print(config, elementToPrint || data);
  }

  strip(key) {
    if (key.indexOf('-----') !== -1) {
      return key.split('-----')[2].replace(/\r?\n|\r/g, '');
    }
  }

}
